/**
 * ROCK_ARCHETYPE
 *
 * Statistical profile for Rock, Punk, Metal, and Blues.
 * Focuses on high energy, rhythmic lock, and power chord structures.
 */

import { ACTIVE_ARCHETYPE } from './BaseArchetype.js';

export const ROCK_ARCHETYPE = {
    ...ACTIVE_ARCHETYPE,

    // Harmonic Rhythm: Moderate to Fast
    harmonicRhythm: {
        ...ACTIVE_ARCHETYPE.harmonicRhythm,
        target: 2.0, // 2 bars (or 1 bar) per chord
        tolerance: 1.0,
        weight: 0.15
    },

    // Harmonic Consonance: Consonant (Power Chords)
    harmonicConsonance: {
        ...ACTIVE_ARCHETYPE.harmonicConsonance,
        polarity: 'consonant',
        weight: 0.1
    },

    // Voice Distribution: Guitar-centric (Mid-Heavy)
    voiceDistribution: {
        ...ACTIVE_ARCHETYPE.voiceDistribution,
        low: 0.25,  // Bass/Kick
        mid: 0.50,  // Guitars/Vocals
        high: 0.25, // Cymbals/Solos
        tolerance: 0.2,
        tuttiThreshold: 0.8,
        weight: 0.2
    },

    // Dynamic Range: Loud (Compressed)
    dynamicRange: {
        ...ACTIVE_ARCHETYPE.dynamicRange,
        minVariance: 0.05, // Consistent high energy
        targetVariance: 0.1,
        dynamicShape: 'stepwise' // Section-based shifts (Verse vs Chorus)
    },

    // Interval Entropy: Riff-based (Repetitive)
    intervalEntropy: {
        ...ACTIVE_ARCHETYPE.intervalEntropy,
        stepRatio: 0.6, // Mix of steps and small skips
        weight: 0.1
    },

    // Rhythmic Lock: CRITICAL. Bass and Kick must lock.
    rhythmicLock: {
        ...ACTIVE_ARCHETYPE.rhythmicLock,
        weight: 0.4 // Very High Priority
    },

    motivicRepetition: {
        ...ACTIVE_ARCHETYPE.motivicRepetition,
        target: 0.7, // High repetition (Riffs)
        weight: 0.2
    }
};
